import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

export function ReloadButton() {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      data-testid="error-page-reload-button"
      onClick={() => window.location.reload()}
    >
      {t('error_page.actions.reload')}
    </Button>
  );
}

export function RetryButton({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();

  return (
    <Button variant="contained" data-testid="error-page-retry-button" onClick={onRetry}>
      {t('error_page.actions.retry')}
    </Button>
  );
}
